<template>
  <div class="col-md-12">
    <!-- Tabs mejorados -->
    <ul class="nav nav-tabs nav-tabs-custom" id="vehiculosTab" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="tab-VehAct"
          data-toggle="tab"
          href="#VehAct"
          v-show="Object.keys($parent.vehiculosAct).length > 0"
          role="tab"
        >
          <i class="fas fa-truck-moving mr-1"></i>
          <span class="badge badge-success mr-1">{{
            $parent.vehiculosAct.total || 0
          }}</span>
          Activos
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="tab-VehPost"
          data-toggle="tab"
          href="#VehPost"
          v-show="Object.keys($parent.vehiculosPost).length > 0"
          role="tab"
        >
          <i class="fas fa-clock mr-1"></i>
          <span class="badge badge-warning mr-1">{{
            $parent.vehiculosPost.total || 0
          }}</span>
          Postulados
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="tab-VehInact"
          data-toggle="tab"
          href="#VehInact"
          v-show="Object.keys($parent.vehiculosInact).length > 0"
          role="tab"
        >
          <i class="fas fa-pause-circle mr-1"></i>
          <span class="badge badge-danger mr-1">{{
            $parent.vehiculosInact.total || 0
          }}</span>
          Inactivos
        </a>
      </li>
    </ul>

    <div class="tab-content" id="vehiculosTabContent">
      <!-- Tab Activos -->
      <div
        class="tab-pane fade active show"
        id="VehAct"
        v-show="Object.keys($parent.vehiculosAct).length > 0"
        role="tabpanel"
      >
        <div class="p-0">
          <div class="table-responsive">
            <table
              id="activos"
              class="table table-bordered table-striped table-hover table-sm text-nowrap m-0"
            >
              <thead class="thead-dark">
                <tr>
                  <th colspan="10" class="text-center">
                    <i class="fas fa-info-circle mr-1"></i>
                    Información del Viaje
                  </th>
                  <th colspan="4" class="text-center">
                    <i class="fas fa-map-marker-alt mr-1"></i>
                    Último Registro GPS
                  </th>
                </tr>
                <tr>
                  <th class="text-center">
                    <i class="fas fa-route mr-1"></i>Viaje
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.viajeAct"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar viaje"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-file-alt mr-1"></i>Guía
                    <input
                      type="number"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.guiaAct"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar guía"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-ticket-alt mr-1"></i>Ticket
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.ticketAct"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar ticket"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-truck mr-1"></i>Vehículo
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.vehiAct"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar vehículo"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-gas-pump mr-1"></i>Tipo Combust.
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.tipoCombAct"
                      placeholder="Tipo Combustible"
                      label="descripcion"
                      :options="$parent.listasForms.tipos_combustibles"
                      @input="getTipoCombustible('activo')"
                      multiple
                      class="mt-1"
                    ></v-select>
                  </th>
                  <th class="text-center">
                    <i class="fas fa-trailer mr-1"></i>Remolque
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.remAct"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar remolque"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-user mr-1"></i>Conductor
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.condAct"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar conductor"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-building mr-1"></i>Transportadora
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.transAct"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar transportadora"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-route mr-1"></i>Ruta
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.rutaAct"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar ruta"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-map-marker mr-1"></i>Último Punto
                  </th>
                  <th class="text-center">
                    <i class="fas fa-calendar mr-1"></i>Fecha Cita
                  </th>
                  <th class="text-center">
                    <i class="fas fa-globe mr-1"></i>Latitud
                  </th>
                  <th class="text-center">
                    <i class="fas fa-globe mr-1"></i>Longitud
                  </th>
                  <th class="text-center">
                    <i class="fas fa-map mr-1"></i>Dirección
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in $parent.vehiculosAct.data" :key="item.id">
                  <td>
                    <button
                      type="button"
                      class="btn btn-sm btn-default py-0"
                      data-toggle="modal"
                      data-target="#modal-form-detViaje"
                      @click="
                        llenarModalDetViaje(
                          item.viajes[0].id,
                          item.viajes[0].tipo_operacion
                        )
                      "
                    >
                      {{ item.viajes[0].id }}
                    </button>
                  </td>
                  <td
                    v-if="
                      item.viajes[0].guia !== null &&
                        item.viajes[0].guia !== undefined
                    "
                  >
                    <span class="badge badge-success">
                      {{ item.viajes[0].guia.numero }}-{{
                        item.viajes[0].guia.digito_verificacion
                      }}
                    </span>
                  </td>
                  <td v-else>
                    <span class="badge badge-danger"> Sin Asignar </span>
                  </td>
                  <td
                    v-if="
                      item.viajes[0].ticket !== null &&
                        item.viajes[0].ticket !== undefined
                    "
                  >
                    <span class="badge badge-success">
                      {{ item.viajes[0].ticket.numero_ticket }}
                    </span>
                  </td>
                  <td v-else>
                    <span class="badge badge-danger"> Sin Asignar </span>
                  </td>
                  <td class="text-center">
                    {{ item.placa }}
                  </td>
                  <td class="text-center">
                    <span
                      class="badge ml-1 mr-1"
                      :class="
                        item.tipo_combustible == 1
                          ? 'badge-warning'
                          : 'badge-info'
                      "
                    >
                      {{ item.nCombustible }}
                    </span>
                  </td>
                  <td>
                    {{ item.viajes[0].remolque.placa }}
                  </td>
                  <td>
                    {{ item.viajes[0].conductor.apellidos }}
                    {{ item.viajes[0].conductor.nombres }}
                  </td>
                  <td>
                    {{ item.viajes[0].transportadora.razon_social }}
                  </td>
                  <td v-if="item.viajes[0].rutaViaje">
                    {{ item.viajes[0].rutaViaje }}
                  </td>
                  <td v-else></td>
                  <td
                    v-if="
                      item.viajes[0].sitio !== null &&
                        item.viajes[0].sitio !== undefined
                    "
                  >
                    {{ item.viajes[0].sitio.nombre }}
                  </td>
                  <td v-else></td>
                  <td v-if="item.viajes[0].cita_cargue !== null">
                    {{ item.viajes[0].cita_cargue }}
                  </td>
                  <td v-if="item.ultimo_registro != null">
                    {{ item.ultimo_registro.gps.dblLatitud }}
                  </td>
                  <td v-else></td>
                  <td v-if="item.ultimo_registro != null">
                    {{ item.ultimo_registro.gps.dblLongitud }}
                  </td>
                  <td v-else></td>
                  <td v-if="item.ultimo_registro != null">
                    {{ item.ultimo_registro.gps.strDireccion }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Footer mejorado -->
          <div class="card-footer p-2">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div v-if="$parent.vehiculosAct.total" class="text-muted">
                  <i class="fas fa-info-circle mr-1"></i>
                  Mostrando del
                  <strong>{{ $parent.vehiculosAct.from }}</strong> al
                  <strong>{{ $parent.vehiculosAct.to }}</strong> de un total:
                  <strong>{{ $parent.vehiculosAct.total }}</strong> Registros
                </div>
                <div v-else>
                  <span class="badge badge-danger">
                    <i class="fas fa-exclamation-triangle mr-1"></i>
                    No hay registros para mostrar
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <pagination
                  :data="$parent.vehiculosAct"
                  class="float-right m-0"
                  @pagination-change-page="$parent.getIndex"
                  :limit="10"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Tab Postulados -->
      <div
        class="tab-pane fade"
        id="VehPost"
        v-show="Object.keys($parent.vehiculosPost).length > 0"
        role="tabpanel"
      >
        <div class="p-0">
          <div class="table-responsive">
            <table
              id="postulados"
              class="table table-bordered table-striped table-hover table-sm text-nowrap m-0"
            >
              <thead class="thead-dark">
                <tr>
                  <th colspan="5" class="text-center">
                    <i class="fas fa-info-circle mr-1"></i>
                    Información del Vehículo
                  </th>
                  <th colspan="4" class="text-center">
                    <i class="fas fa-map-marker-alt mr-1"></i>
                    Último Registro GPS
                  </th>
                </tr>
                <tr>
                  <th class="text-center">
                    <i class="fas fa-truck mr-1"></i>Vehículo
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.vehiPost"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar vehículo"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-gas-pump mr-1"></i>Tipo Combust.
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.tipoCombPost"
                      placeholder="Tipo Combustible"
                      label="descripcion"
                      :options="$parent.listasForms.tipos_combustibles"
                      @input="getTipoCombustible('postulado')"
                      multiple
                      class="mt-1"
                    ></v-select>
                  </th>
                  <th class="text-center">
                    <i class="fas fa-trailer mr-1"></i>Remolque
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.remPost"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar remolque"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-user mr-1"></i>Conductor
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.condPost"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar conductor"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-building mr-1"></i>Transportadora
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.transPost"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar transportadora"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-calendar mr-1"></i>Fecha Cita
                  </th>
                  <th class="text-center">
                    <i class="fas fa-globe mr-1"></i>Latitud
                  </th>
                  <th class="text-center">
                    <i class="fas fa-globe mr-1"></i>Longitud
                  </th>
                  <th class="text-center">
                    <i class="fas fa-map mr-1"></i>Dirección
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in $parent.vehiculosPost.data" :key="item.id">
                  <td>
                    {{ item.placa }}
                  </td>
                  <td class="text-center">
                    <span
                      class="badge ml-1 mr-1"
                      :class="
                        item.tipo_combustible == 1
                          ? 'badge-warning'
                          : 'badge-info'
                      "
                    >
                      {{ item.nCombustible }}
                    </span>
                  </td>
                  <td>
                    {{
                      item.det_postulaciones[0] &&
                      item.det_postulaciones[0].remolque
                        ? item.det_postulaciones[0].remolque.placa
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      item.det_postulaciones[0] &&
                      item.det_postulaciones[0].conductor
                        ? item.det_postulaciones[0].conductor.apellidos
                        : ""
                    }}
                    {{
                      item.det_postulaciones[0] &&
                      item.det_postulaciones[0].conductor
                        ? item.det_postulaciones[0].conductor.nombres
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      item.det_postulaciones[0].det_solicitud_diaria.empresa
                        .razon_social
                    }}
                  </td>
                  <td>
                    {{
                      item.det_postulaciones[0] &&
                      item.det_postulaciones[0].det_solicitud_diaria
                        ? item.det_postulaciones[0].det_solicitud_diaria
                            .solicitud_diaria.fecha
                        : ""
                    }}
                    {{
                      item.det_postulaciones[0] &&
                      item.det_postulaciones[0].det_solicitud_diaria
                        ? item.det_postulaciones[0].det_solicitud_diaria.cita
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      item.ultimo_registro
                        ? item.ultimo_registro.gps.dblLatitud
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      item.ultimo_registro
                        ? item.ultimo_registro.gps.dblLongitud
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      item.ultimo_registro
                        ? item.ultimo_registro.gps.strDireccion
                        : ""
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Footer mejorado -->
          <div class="card-footer p-2">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div v-if="$parent.vehiculosPost.total" class="text-muted">
                  <i class="fas fa-info-circle mr-1"></i>
                  Mostrando del
                  <strong>{{ $parent.vehiculosPost.from }}</strong> al
                  <strong>{{ $parent.vehiculosPost.to }}</strong> de un total:
                  <strong>{{ $parent.vehiculosPost.total }}</strong> Registros
                </div>
                <div v-else>
                  <span class="badge badge-danger">
                    <i class="fas fa-exclamation-triangle mr-1"></i>
                    No hay registros para mostrar
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <pagination
                  :data="$parent.vehiculosPost"
                  class="float-right m-0"
                  @pagination-change-page="$parent.getIndex"
                  :limit="10"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Tab Inactivos -->
      <div
        class="tab-pane fade"
        id="VehInact"
        v-show="Object.keys($parent.vehiculosInact).length > 0"
        role="tabpanel"
      >
        <div class="p-0">
          <div class="table-responsive">
            <table
              id="inactivos"
              class="table table-bordered table-striped table-hover table-sm text-nowrap m-0"
            >
              <thead class="thead-dark">
                <tr>
                  <th colspan="3" class="text-center">
                    <i class="fas fa-info-circle mr-1"></i>
                    Información del Vehículo
                  </th>
                  <th colspan="3" class="text-center">
                    <i class="fas fa-map-marker-alt mr-1"></i>
                    Último Registro GPS
                  </th>
                </tr>
                <tr>
                  <th class="text-center">
                    <i class="fas fa-truck mr-1"></i>Vehículo
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.vehiInact"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar vehículo"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-gas-pump mr-1"></i>Tipo Combust.
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.tipoCombInact"
                      placeholder="Tipo Combustible"
                      label="descripcion"
                      :options="$parent.listasForms.tipos_combustibles"
                      @input="getTipoCombustible('inactivo')"
                      multiple
                      class="mt-1"
                    ></v-select>
                  </th>
                  <th class="text-center">
                    <i class="fas fa-building mr-1"></i>Transportadora
                    <input
                      type="text"
                      class="form-control form-control-sm mt-1"
                      v-model="filtros.transInact"
                      @keyup.enter="$parent.getIndex()"
                      placeholder="Filtrar transportadora"
                    />
                  </th>
                  <th class="text-center">
                    <i class="fas fa-globe mr-1"></i>Latitud
                  </th>
                  <th class="text-center">
                    <i class="fas fa-globe mr-1"></i>Longitud
                  </th>
                  <th class="text-center">
                    <i class="fas fa-map mr-1"></i>Dirección
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in $parent.vehiculosInact.data" :key="item.id">
                  <td>
                    {{ item.placa }}
                  </td>
                  <td class="text-center">
                    <span
                      class="badge ml-1 mr-1"
                      :class="
                        item.tipo_combustible == 1
                          ? 'badge-warning'
                          : 'badge-info'
                      "
                    >
                      {{ item.nCombustible }}
                    </span>
                  </td>
                  <td>
                    {{ item.empresa.razon_social }}
                  </td>
                  <td v-if="item.ultimo_registro != null">
                    {{ item.ultimo_registro.gps.dblLatitud }}
                  </td>
                  <td v-else></td>
                  <td v-if="item.ultimo_registro != null">
                    {{ item.ultimo_registro.gps.dblLongitud }}
                  </td>
                  <td v-else></td>
                  <td v-if="item.ultimo_registro != null">
                    {{ item.ultimo_registro.gps.strDireccion }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Footer mejorado -->
          <div class="card-footer p-2">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div v-if="$parent.vehiculosInact.total" class="text-muted">
                  <i class="fas fa-info-circle mr-1"></i>
                  Mostrando del
                  <strong>{{ $parent.vehiculosInact.from }}</strong> al
                  <strong>{{ $parent.vehiculosInact.to }}</strong> de un total:
                  <strong>{{ $parent.vehiculosInact.total }}</strong> Registros
                </div>
                <div v-else>
                  <span class="badge badge-danger">
                    <i class="fas fa-exclamation-triangle mr-1"></i>
                    No hay registros para mostrar
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <pagination
                  :data="$parent.vehiculosInact"
                  class="float-right m-0"
                  @pagination-change-page="$parent.getIndex"
                  :limit="10"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from "laravel-vue-pagination";
import vSelect from "vue-select";

export default {
  name: "MapasListVehiculos",
  components: {
    pagination,
    vSelect,
  },
  data() {
    return {
      filtros: {},
    };
  },

  methods: {
    llenarModalDetViaje(viaje, tipo_control) {
      this.$parent.$refs.ViajesDetViaje.llenar_modal_detViaje(
        viaje,
        tipo_control
      );
    },

    getTipoCombustible(tipo) {
      this.filtros.tipo_combustible_act = [];
      this.filtros.tipo_combustible_post = [];
      this.filtros.tipo_combustible_inact = [];

      switch (tipo) {
        case "activo":
          this.filtros.tipoCombAct.forEach((tip) => {
            this.filtros.tipo_combustible_act.push(tip.numeracion);
          });
          break;

        case "postulado":
          this.filtros.tipoCombPost.forEach((tip) => {
            this.filtros.tipo_combustible_post.push(tip.numeracion);
          });
          break;

        case "inactivo":
          this.filtros.tipoCombInact.forEach((tip) => {
            this.filtros.tipo_combustible_inact.push(tip.numeracion);
          });
          break;
      }

      this.$parent.getIndex();
    },

    //Funcion para traer la direccion segun latitud y longitud
    /* decodeLatLong(lat, long) {
      this.$gmapApiPromiseLazy().then(() => {
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode(
          {
            location: {
              lat: parseInt(lat),
              lng: parseInt(long),
            },
          },
          (results, status) => {
            if (status === "OK") {
              this.getFromAutocomplete(results[0]);
            }
          }
        );
      });
    } */
  },
};
</script>
